<template>
  <div class="NewsDetails">
    <banner img="@/assets/img/bgtop.jpg" />
    <div class="NewsDetails-product">
      <div class="NewsDetails-product-content">
        <img :src="newsIdList.Img" alt />
        <p class="product-title">{{ newsIdList.Title }}</p>
        <p class="product-time">{{ newsIdList.CreateTime }}</p>
        <p class="product-content">{{ newsIdList.Content }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "@/components/Banner";
export default {
  name: "NewsDetails",
  components: {
    Banner,
  },
  data() {
    return {
      pid: 0,
      newsIdList: {},
      List: [
        {
          Id: "1",
          Title: "三九999颗粒感冒 冲剂头痛发热鼻塞流涕咽痛解热镇痛",
          Img: require("@/assets/img/YaoPin1.png"),
          CreateTime: "2024-04-16 17:51",
          Content:
            "该产品为浅棕色至深棕色的颗粒，味甜、微苦。具有解热镇痛的功效，用于因感冒引起的头痛，发热，鼻塞，流涕，咽痛等症状。每盒含9包，每包袋装10g。",
        },
        {
          Id: "2",
          Title: "止咳糖浆",
          Img: require("@/assets/img/YaoPin2.png"),
          CreateTime: "2024-04-22 18:05",
          Content:
            "止咳糖浆主要用于止咳，化痰。适用于感冒、咳嗽、多痰、支气管性气喘等症。属于处方药。 咳嗽是呼吸系统受到刺激时产生的一种防御性反射活动。轻微的咳嗽能清除气管内的痰液与异物，可自然缓解，一般不需服用止咳药；强烈而频繁的咳嗽，尤其是干咳，可能使病情加重而引起并发症，因此需要在治疗的同时加用止咳药。",
        },
        {
          Id: "3",
          Title: "黄莲",
          Img: require("@/assets/img/YaoPin3.png"),
          CreateTime: " 2024-06-07 15:44",
          Content:
            "惯和购物需求发生了显著变化，更注重个性化、便捷化和体验化。这使得传统实体店在吸引年轻消费者方面面临挑战。市场需求旺盛：随着社会老龄化的加速推进，居家养老成为越来越多老年人的首选。他们对居家养老服务的需求日益增长，为产业发展提供了广阔的市场空间。政策支持力度加大：为应对老龄化挑战，政府出台了一系列政策措施，鼓励和支持居家养老产业的发展。这些政策为居家养老服务机构提供了更多的发展机会和优惠政策。创新服务模式不断涌现：随着科技的进步，越来越多的创新服务模式应用于居家养老领域，如智能养老设备、远程医疗服务等。这些创新服务模式不仅提升了服务质量，也满足了老年人的多样化需求。",
        },
      ],
    };
  },
  created() {
    this.pid = this.$route.params.id;
    window.console.log(this.pid);
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.List.forEach((item) => {
        if (item.Id == this.pid) {
          this.newsIdList = item;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.NewsDetails {
  width: 100%;
  height: 100%;
  //overflow: hidden;
  background-color: #14679f;
  &-product {
    width: 1240px;
    margin: 0 auto;
    background-color: #fff;
    border: 1px solid red;
    &-content {
      width: 760px;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      padding: 50px 0;
      img {
        width: 100%;
        //height: 500px;
      }
      .product-title {
        font-size: 25px;
        color: #e13834;
        padding: 20px 0;
      }
      .product-content {
        font-size: 17px;
        font-weight: bolder;
        padding: 20px 0;
      }
    }
  }
}
</style>